import CampaignsApplicationsList from "./campaignsApplicationsList";

export default {
  list: CampaignsApplicationsList,
};
